import { useCurrentMedia } from '@hooks/useCurrentMedia'
import { useGetMedia } from '@services/api/graphql/getMedia'
import { BaseImageViewer } from './BaseImageViewer'

export function ExtraContentImageViewerPage() {
  const { currentMedia } = useCurrentMedia()
  const media = currentMedia?.media

  const { data: mediaData, loading: isLoadingMedia } = useGetMedia({
    courseId: currentMedia?.courseId?.toString() ?? '0',
    enrollmentId: currentMedia?.enrollmentId?.toString() ?? '0',
    id: media?.id?.toString() ?? '0',
    enabled: !!media?.id,
  })

  const fileUrl = mediaData?.media?.fileUrl

  return (
    <BaseImageViewer
      media={media}
      fileUrl={fileUrl}
      isLoading={isLoadingMedia}
    />
  )
}
